import React, { useMemo } from 'react';
import style from '../display-tooltip.module.less';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faScannerGun } from '@fortawesome/sharp-regular-svg-icons/faScannerGun';
import { useMaxZ } from 'ui-components/hooks/services/use-max-z';
import { FormattedMessage, defineMessages } from 'react-intl';

const messages = defineMessages({
  scan: {
    defaultMessage: 'Retrieving scanned item',
    id: 'yUjOEu',
    description: 'App wide Scan to View',
  },
});

export const ScanToViewTooltip = () => {
  const zIndex = useMaxZ();
  const zIndexStyle = useMemo(() => ({ zIndex }), [zIndex]);

  return (
    <div className={style['tooltip-wrapper']} style={zIndexStyle}>
      <FontAwesomeIcon className={style['display-icon']} icon={faScannerGun} />
      <b>
        <FormattedMessage {...messages.scan} />
      </b>
    </div>
  );
};
